<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tabs/home" text=""></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-content__subpage">
  <div class="impact-item__header">
    <div class="label">
      {{ 'INSIGHTS.impact.engagement.category' | translate }}
      <img src="/assets/icon/engagement.svg" />
    </div>
    <ng-container *ngIf="!campaignExpired; else alreadyExpired">
      <p>{{ 'INSIGHTS.impact.engagement.until' | translate }} {{ campaignExpiresAt | dateTranslate: 'longMonth' : language }}</p>
    </ng-container>
    <ng-template #alreadyExpired>
      <p>{{ campaignExpiresAt | dateTranslate: 'shortDate' : language }}</p>
    </ng-template>
    <h1>{{ story?.title }}</h1>
  </div>
  <div class="impact-item__subtitle">
    <p [innerHTML]="story?.subtitle"></p>
  </div>
  <div class="impact-item__image" [ngStyle]="{ backgroundImage: 'url(' + story?.image + ')' }"></div>
  <ng-container *ngIf="campaignEngaged !== undefined">
    <div class="impact-item-notification" *ngIf="campaignExpired && !campaignEngaged">
      <img src="/assets/icon/info.svg" />
      <p>{{ 'INSIGHTS.impact.engagement.message.expired.content' | translate }}</p>
    </div>
    <div class="impact-item-notification success" *ngIf="campaignEngaged && campaignLiked">
      <img src="/assets/icon/engagement.svg" />
      <p>
        <span class="bold">{{ 'INSIGHTS.impact.engagement.message.like.title' | translate }}</span>
        <span>{{ 'INSIGHTS.impact.engagement.message.like.content' | translate }}</span>
      </p>
    </div>
  </ng-container>
  <div class="impact-item__cta" *ngIf="smallScreen">
    <button
      *ngIf="showCampaignActions"
      (click)="engageCampaign(true)"
      [ngClass]="{ animateOn: buttonLiked, animateOff: !buttonLiked, loading: loadingCampaignLike }"
    >
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 17.9875V8H8C8 13.525 12.475 18 18 17.9875L8 18V28C13.525 28 18 23.525 18 17.9875L28 18V8C22.4875 8 18.0125 12.4625 18 17.9875Z"
          fill="white"
        />
      </svg>
      <span
        [attr.love]="'INSIGHTS.impact.engagement.cta.clicked' | translate"
        [attr.engage]="'INSIGHTS.impact.engagement.cta.default' | translate"
      ></span>
    </button>
  </div>
  <div class="impact-item__content">
    <p *ngIf="loadingStory"><ion-skeleton-text animated></ion-skeleton-text></p>
    <p *ngIf="loadingStory"><ion-skeleton-text animated></ion-skeleton-text></p>
    <p *ngIf="!loadingStory" [innerHTML]="story?.content" (click)="onArticleClicked($event)"></p>

    <div class="align--center">
      <p class="bold" (click)="openArticle(story?.link)">{{ 'INSIGHTS.impact.engagement.readMore' | translate }}</p>
      <p>
        {{ 'INSIGHTS.impact.engagement.contact' | translate }}
        <b>
          <a routerLink="/tabs/account/support" routerLinkActive="router-link-active" (click)="track('[Link] Engagement: Contact us')">
            {{ 'SHARED.actions.contactUs' | translate }}
          </a>
        </b>
      </p>
      <p *ngIf="showCampaignActions" class="bold" (click)="engageCampaign(false); track('[Button] Engagement: Dislike campaign')">
        {{ 'INSIGHTS.impact.engagement.cta.dislike' | translate }}. {{ 'INSIGHTS.impact.engagement.dislike' | translate }}
      </p>
    </div>
  </div>
  <div class="impact-item__footer" slot="fixed" *ngIf="!smallScreen && showCampaignActions">
    <button (click)="engageCampaign(true)" [ngClass]="{ animateOn: buttonLiked, animateOff: !buttonLiked, loading: loadingCampaignLike }">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 17.9875V8H8C8 13.525 12.475 18 18 17.9875L8 18V28C13.525 28 18 23.525 18 17.9875L28 18V8C22.4875 8 18.0125 12.4625 18 17.9875Z"
          fill="white"
        />
      </svg>
      <span
        [attr.love]="'INSIGHTS.impact.engagement.cta.clicked' | translate"
        [attr.engage]="'INSIGHTS.impact.engagement.cta.default' | translate"
      ></span>
    </button>
  </div>
</ion-content>
